import { render, staticRenderFns } from "./_OrderHistory.vue?vue&type=template&id=20994e16&"
import script from "./_OrderHistory.vue?vue&type=script&lang=js&"
export * from "./_OrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports